import { render, staticRenderFns } from "./RequestReceipt.vue?vue&type=template&id=0f637d02"
import script from "./RequestReceipt.vue?vue&type=script&lang=js"
export * from "./RequestReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports